export const defaultSettings = {}
